export default "__VITE_ASSET__DNa$b5IF__"